import placeholderIcon from "../../images/Placeholder-Icon.svg";
import loanLibraryIcon from "../../images/Loan_Library.svg";
import loanManagementIcon from "../../images/Loan_Management.svg";
import userManagementIcon from "../../images/User_Management.svg";
import reportsIcon from "../../images/Reports.svg";
import ownLibraryIcon from "../../images/Own-Library.svg";
import ownManagementIcon from "../../images/Own-Management.svg";

export const icons = {
    "Loan-Library": loanLibraryIcon,
    "Loan-Management": loanManagementIcon,
    "User-Management": userManagementIcon,
    "Reports": reportsIcon,
    "Own-Catalog": ownLibraryIcon,
    "Own-Loan-Management": ownManagementIcon,
  };

  export const iconTitles = {
    LOAN_LIBRARY: "Loan-Library",
    LOAN_MANAGEMENT: "Loan-Management",
    USER_MANAGEMENT: "User-Management",
    REPORTS: "Reports",
    OWN_CATALOG: "Own-Catalog",
    OWN_LOAN_MANAGEMENT: "Own-Loan-Management",


  }